<template>
  <el-dialog :visible.sync="visible" width="75vw" :before-close="onClose"
    :title="mode === 'view' ? '查看采收记录' : '审核采收记录'">
    <el-form label-width="140px">
      <!-- 只读详情 -->
      <el-row :gutter="12" style="margin-bottom: 12px">
        <el-col :span="8">
          <el-form-item label="批次号">
            <div>{{ currentRecord && currentRecord.batchNumber }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采收日期">
            <div>
              {{ formatDate(currentRecord && currentRecord.harvestDate) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="基地名称">
            <div>{{ currentRecord && currentRecord.plantingBase }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="大棚编号">
            <div>{{ currentRecord && currentRecord.greenhouseName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="草莓品种">
            <div>{{ currentRecord && currentRecord.varietyName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采收负责人">
            <div>{{ currentRecord && currentRecord.harvestManager }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采收草莓总量 (kg)">
            <div>
              {{
                currentRecord && currentRecord.sumWeight
                  ? currentRecord.sumWeight
                  : currentRecord && currentRecord.weight
              }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="仓储位置">
            <div>{{ currentRecord && currentRecord.basicStorageName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="品控员">
            <div>{{ currentRecord && currentRecord.reviewer }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件">
            <div style="display: flex; gap: 8px; flex-wrap: wrap" v-if="
              currentRecord &&
              currentRecord.attachment &&
              currentRecord.attachment.length
            ">
              <el-image v-for="(att, idx) in currentRecord.attachment" :key="idx" :src="att.url || att.path || att"
                :preview-src-list="getPreviewSrcList(currentRecord.attachment)"
                style="width: 80px; height: 60px; cursor: pointer" fit="cover" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="currentRecord?.sumPackWeight && showLossWeight" label=" 总包装重量">
        <div style="display: flex; gap: 8px; align-items: center">
          <div>
            <strong>{{ currentRecord?.sumPackWeight }}</strong> kg
          </div>
          <div style="margin-left: 12px">
            坏果量：<strong>{{ currentRecord.lossWeight }}</strong> kg
            <span style="color: red; font-size: 12px; margin-left: 8px">
              注：坏果量=采收草莓总量-各分级规格重量
            </span>
          </div>
        </div>
      </el-form-item>
      <!-- 包装详情（仅当存在时显示） -->
      <el-form-item label="包装详情" v-if="
        currentRecord &&
        Array.isArray(currentRecord.harvestDtlList) &&
        currentRecord.harvestDtlList.length
      ">
        <el-table :data="currentRecord.harvestDtlList" border size="small" style="width: 100%">
          <el-table-column prop="specSize" label="分级规格" width="160">
            <template slot-scope="{ row }">{{
              mapSpec(row.specSize)
            }}</template>
          </el-table-column>
          <el-table-column prop="weight" label="重量 (kg)" width="120" />
          <el-table-column prop="boxes" label="包装数量 (盒)" width="120" />
          <el-table-column prop="basicStorageName" label="仓储位置" width="180" />
          <el-table-column prop="batchNumber" label="包装批次号" width="180" />
          <el-table-column label="附件">
            <template slot-scope="{ row }">
              <div style="display: flex; gap: 8px">
                <el-image v-for="(att, idx) in row.attachment || []" :key="idx" :src="att.url || att.path || att"
                  :preview-src-list="getPreviewSrcList(row.attachment || [])"
                  style="width: 60px; height: 40px; cursor: pointer" fit="cover" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <!-- 审核记录（仅当存在时显示） -->
      <!-- <el-form-item label="审核记录" v-if="currentRecord && Array.isArray(currentRecord.reviewLogList) && currentRecord.reviewLogList.length">
        <el-table :data="currentRecord.reviewLogList" border size="small" style="width:100%;">
          <el-table-column prop="reviewer" label="审核人" width="160" />
          <el-table-column prop="reviewMsg" label="审核意见" />
          <el-table-column prop="reviewTime" label="审核时间" width="160">
            <template slot-scope="{ row }">{{ formatDate(row.reviewTime) }}</template>
          </el-table-column>
          <el-table-column prop="packaged" label="交付包装" width="100">
            <template slot-scope="{ row }">{{ row.packaged ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="deliveryDate" label="交付日期" width="120">
            <template slot-scope="{ row }">{{ formatDate(row.deliveryDate) }}</template>
          </el-table-column>
        </el-table>
      </el-form-item> -->

      <!-- 编辑区：仅在 review 模式显示 -->
      <div v-if="mode === 'review'">
        <el-form-item label="品控员">
          <div style="display: flex; align-items: center; gap: 8px">
            <div>{{ displayedReviewer }}</div>
            <el-button size="mini" @click="onUpdateReviewer">更新</el-button>
          </div>
        </el-form-item>

        <el-form-item label="是否交付包装">
          <el-radio-group v-model="localForm.deliverToPackaging">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="交付包装日期" v-if="localForm.deliverToPackaging === true" required>
          <el-date-picker v-model="localForm.packagingDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            style="width: 240px" />
        </el-form-item>

        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="3" v-model="localForm.reviewComment" placeholder="可填写审核说明（非必填）" />
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer" style="text-align: right">
      <el-button @click="onClose">取消</el-button>
      <template v-if="mode === 'review'">
        <el-button type="warning" @click="onReject">退回</el-button>
        <el-button type="success" @click="onApprove">审核通过</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "ReviewDialog",
  props: {
    visible: { type: Boolean, required: true },
    mode: { type: String, default: "view" }, // 'view' | 'review'
    currentRecord: { type: Object, default: null },
    userInfo: { type: Object, default: null },
    showLossWeight: { type: Boolean, default: true },
  },
  data() {
    return {
      localForm: {
        deliverToPackaging: false,
        packagingDate: null,
        reviewComment: "",
      },
    };
  },
  watch: {
    currentRecord: {
      immediate: true,
      handler(n) {
        if (n) {
          this.localForm.deliverToPackaging = !!n.packaged;
          this.localForm.packagingDate = n.deliveryDate || null;
          this.localForm.reviewComment = "";
        }
      },
    },
    "localForm.deliverToPackaging": function (newVal) {
      // 当选择"否"时，清空交付包装日期
      if (!newVal) {
        this.localForm.packagingDate = null;
      }
    },
  },
  computed: {
    displayedReviewer() {
      try {
        const logs = this.currentRecord && this.currentRecord.reviewLogList;
        if (Array.isArray(logs) && logs.length > 0) {
          const last = logs[logs.length - 1];
          return last.reviewer || last.reviewerName || "";
        }
      } catch (e) { }
      if (
        this.currentRecord &&
        (this.currentRecord.reviewer || this.currentRecord.reviewerName)
      ) {
        return this.currentRecord.reviewerName || this.currentRecord.reviewer;
      }
      return (
        (this.userInfo && (this.userInfo.nickName || this.userInfo.username)) ||
        ""
      );
    },
  },
  methods: {
    formatDate(v) {
      if (!v) return "";
      try {
        return dayjs(v).format("YYYY/MM/DD");
      } catch (e) {
        return v;
      }
    },
    getPreviewSrcList(attachments) {
      if (!Array.isArray(attachments)) return [];
      return attachments.map((att) => att.url || att.path || att);
    },
    mapSpec(s) {
      const map = {
        LARGE: "大果(特级果)",
        MEDIUM: "中果(优质果)",
        SMALL: "小果(精品果)",
        INFERIOR: "次果",
        BABY: '宝宝果',
        BASKET: '蓝装草莓'
      };
      return map[s] || s || "";
    },
    onUpdateReviewer() {
      this.$emit("update-reviewer", {
        id: this.currentRecord && this.currentRecord.id,
      });
    },
    onApprove() {
      if (
        this.localForm.deliverToPackaging === true &&
        !this.localForm.packagingDate
      ) {
        this.$message &&
          this.$message.error &&
          this.$message.error("请选择交付包装日期");
        return;
      }
      const payload = {
        id: this.currentRecord && this.currentRecord.id,
        deliverToPackaging: !!this.localForm.deliverToPackaging,
        packagingDate: this.localForm.packagingDate,
        reviewComment: this.localForm.reviewComment,
      };
      this.$emit("approve", payload);
    },
    onReject() {
      const payload = {
        id: this.currentRecord && this.currentRecord.id,
        deliverToPackaging: !!this.localForm.deliverToPackaging,
        packagingDate: this.localForm.packagingDate,
        reviewComment: this.localForm.reviewComment,
      };
      this.$emit("reject", payload);
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped></style>
